<template>
  <div id="app">
    <router-view id="view"/>
  </div>
</template>
<script>
window.onresize=function(){
  let body = document.body
  let ratio = (document.body.clientWidth/1440).toFixed(1)
  body.style.fontSize = Math.round(20*ratio) + 'px'
}
</script>
<style>
* {
  padding: 0;
  margin: 0;
}

#app{
}

</style>
